import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React from 'react';
import i18n from 'i18next';
import Flex, { Box } from 'components/Flex';
import Text from 'components/Text';
import HintTooltip from 'components/HintTooltip';
import Switch from 'components/Switch';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function getReadout(enabled) {
  return enabled ? i18n.t('state_enabled') : i18n.t('state_disabled');
}
function SwitchField(_ref) {
  var description = _ref.description,
    disabled = _ref.disabled,
    id = _ref.id,
    value = _ref.value,
    invertUiValue = _ref.invertUiValue,
    onChange = _ref.onChange,
    _ref$boldTitle = _ref.boldTitle,
    boldTitle = _ref$boldTitle === void 0 ? true : _ref$boldTitle,
    _ref$readout = _ref.readout,
    readout = _ref$readout === void 0 ? getReadout : _ref$readout,
    title = _ref.title,
    _ref$default = _ref.default,
    defaultValue = _ref$default === void 0 ? false : _ref$default;
  var fieldValue = value !== null && value !== void 0 ? value : defaultValue;
  function toggleSwitch() {
    onChange === null || onChange === void 0 || onChange(id, !fieldValue, title);
  }
  var descriptionId = description ? "".concat(id, "-desc") : undefined;
  var uiValue = invertUiValue ? !fieldValue : fieldValue;
  return /*#__PURE__*/_jsxs(Flex, {
    children: [/*#__PURE__*/_jsx(Box, {
      grow: true,
      shrink: true,
      pr: "m",
      children: /*#__PURE__*/_jsxs(Text, {
        dimmed: disabled,
        children: [/*#__PURE__*/_jsx(Text, {
          bold: boldTitle,
          as: "label",
          htmlFor: id,
          children: title
        }), description && /*#__PURE__*/_jsx(HintTooltip, {
          content: description,
          id: descriptionId,
          spacingLeft: "xxs"
        }), readout && /*#__PURE__*/_jsx(Text, {
          display: "block",
          children: readout(uiValue)
        })]
      })
    }), /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(Switch, {
        id: id,
        disabled: disabled,
        checked: uiValue,
        onChange: toggleSwitch,
        "aria-describedby": descriptionId
      })
    })]
  });
}
export default SwitchField;